export const isTrue = v => v === true || (!!v && v.toString().toLowerCase() === "true");

export const isFalse = v => v === false || (!!v && v.toString().toLowerCase() === "false");

export const isFalseOrMissing = v => isFalse(v) || !v;
